import React from 'react';

import { CreateUpdateProfileCategoryDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface ProfileCategoryEditorFormYearsGridProps {
  profileCategory: CreateUpdateProfileCategoryDto;
  readOnly?: boolean;
  onRowClick?: (id: string) => void;
}

export const ProfileCategoryEditorFormYearsGrid: React.FC<
  ProfileCategoryEditorFormYearsGridProps
> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const COLUMNS: GridColumn[] = [
    { header: t(tk.common.year), property: 'year' },
    {
      header: t(tk.administration.profileCategoryAccountsInternal),
      property: 'internalTxt',
    },
    {
      header: t(tk.administration.salesFinancialAccount),
      property: 'salesFinancialAccount',
    },
    {
      header: t(tk.administration.purchasesFinancialAccount),
      property: 'purchasesFinancialAccount',
    },
    {
      header: t(tk.administration.commissionsFinancialAccount),
      property: 'commissionFinancialAccount',
    },
  ];

  const data = (props.profileCategory.profileCategoriesYears || []).map(
    (year, index) => ({
      key: index.toString(),
      isInactive: !year.active,
      values: {
        ...year,
        internalTxt:
          year.internal === true
            ? t(tk.common.yesUpperCase)
            : year.internal === false
              ? t(tk.common.noUpperCase)
              : '',
        order:
          (year.active ? 'T' : 'F') +
          year.year +
          (year.internal !== undefined
            ? year.internal === true
              ? 'T'
              : 'F'
            : 'U'),
      },
    }),
  ) as unknown as GridRecord[];

  return (
    <>
      <Grid
        data={data}
        columns={COLUMNS}
        initialOrderColumn="order"
        initialOrderDirection="DESC"
        showFilter={false}
        onRowClick={props.readOnly ? undefined : props.onRowClick}
        emptyGridMessage={t(tk.administration.noProfileCategoryYears)}
      />
    </>
  );
};
